export default __webpack_public_path__ + "static/media/mode-bg.a6e98a16.png";